import propertyLoan from "../Assets/Services/property_loan.jpg";
import weddingLoan from "../Assets/Services/wedding_loan.jpg";
import personalLoan from "../Assets/Services/personal_loan.jpg";
import businessLoan from "../Assets/service-three.jpg";
import familyFinance from "../Assets/service11-370x231.jpg";

const approachData = [
  {
    id: 1,
    img: businessLoan,
    slug: "business-loan-guides",
    title: "Business Loan Guides",
    desc: "Learn about common business financing options, eligibility factors, documentation and repayment planning.",
  },
  {
    id: 2,
    img: personalLoan,
    slug: "government-loan-schemes",
    title: "Government Loan Scheme Information",
    desc: "Understand published rules and application processes for schemes such as PMMY and PMEGP. Always verify current details on the official government portal.",
  },
  {
    id: 3,
    img: weddingLoan,
    slug: "women-entrepreneur-finance",
    title: "Women Entrepreneur Loan Information",
    desc: "Read about financing routes women may explore for starting or expanding a business, including MUDRA, PMEGP and other bank or state-level options.",
  },
  {
    id: 4,
    img: propertyLoan,
    slug: "property-loan-information",
    title: "Property Loan Information",
    desc: "Understand common property-loan terms, documentation and questions to ask a lender. PyLoan does not offer or arrange property loans.",
  },
  {
    id: 5,
    img: familyFinance,
    slug: "wedding-expense-finance",
    title: "Wedding Expense Finance: Things to Consider",
    desc: "Learn about budgeting, borrowing costs, repayment obligations and the importance of comparing written terms directly from regulated lenders. PyLoan does not offer wedding loans.",
  },
];

export default approachData;
